import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import Config, { PaginationLimit } from "../../Config";
import {
  MdFileDownload,
  MdFileUpload,
  MdOutlineCurrencyRupee,
} from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";
import { GrUserWorker } from "react-icons/gr";
// import { Tooltip } from "react-tooltip";
import Tooltip from "../Tooltip";
import { FaApple, FaWindows } from "react-icons/fa";
import { DiAndroid } from "react-icons/di";
import { RiEditFill } from "react-icons/ri";
import { IoMdSettings } from "react-icons/io";
import { GrConfigure } from "react-icons/gr";
import { AiOutlineCloudUpload, AiTwotoneBank } from "react-icons/ai";
import { IoCopySharp } from "react-icons/io5";
import { handleCopy } from "../../helpers";

const RecentUsedTable = ({
  apiData,
  setSelectedData,
  openLogs,
  setEditReminder,
  setAddSubAccount,
  setViewDetail,
  userType,
  userId,
  setViewDetailStaff,
  setDownloadPv,
  setRentAgreement,
  setUploadLeads,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  // console.log(apiData);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null); 
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const editreminder = (item) => {
    setEditReminder(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const viewDetail = (item) => {
    setViewDetail(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const downloadpv = (item) => {
    setDownloadPv(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const rentagreement = (item) => {
    setRentAgreement(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const setting = (item) => {
    navigate(`/setting/${item.id}`);
  };

  const clientconfig = (item) => {
    navigate(`/clientconfig/${item.id}`, { state: { name: item.name } });
  };

  const leads = (item) => {
    setUploadLeads(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  // const staff = (item) => {
  //   console.log(item);
  //   navigate(`/Ownerstaff/${item.id}`, { state: { name: item.name } });
  // };

  const goToProperties = (item) => {
    navigate(`/properties/${item.id}`, { state: { name: item?.name } });
  };

  const bank = (item) => {
    navigate(`/bank/${item.id}`, { state: { name: item?.name } });
  };

  // const goToActiveLog = (item) => {
  //   navigate(`/activelogs/${item.id}`);
  // };

  const charges = (item) => {
    navigate(`/charges/${item.id}`, { state: { name: item.name } });
  };

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            {userType != Config.userType.MARKETING && (
              <MenuItem
                title="Edit Reminder"
                onClick={(e) => {
                  e.stopPropagation();
                  editreminder(item);
                }}
              >
                <RiEditFill className="text-gray-700 mr-2" />
                Edit Reminder
              </MenuItem>
            )}

            <MenuItem
              title="View Detail"
              onClick={(e) => {
                e.stopPropagation();
                viewDetail(item);
              }}
            >
              <IoMdEye className="text-gray-700 mr-2" /> View Detail
            </MenuItem>

            <MenuItem
              title="Download PV"
              onClick={(e) => {
                e.stopPropagation();
                downloadpv(item);
              }}
            >
              <MdFileDownload className="text-gray-700 mr-2" />
              Download PV
            </MenuItem>

            {/* <MenuItem title="logo" onClick={() => leads(item)}>
              <AiOutlineCloudUpload className="text-gray-700 mr-2" />
              Upload Leads
            </MenuItem> */}

            <MenuItem
              title="Setting"
              onClick={(e) => {
                e.stopPropagation();
                setting(item);
              }}
            >
              <IoMdSettings className="text-gray-700 mr-2" /> Settings
            </MenuItem>

            <MenuItem
              title="Client Config"
              onClick={(e) => {
                e.stopPropagation();
                clientconfig(item);
              }}
            >
              <GrConfigure className="text-gray-700 mr-2" /> Client Config
            </MenuItem>

            {/* <MenuItem title="Staff" onClick={(e)=> {e.stopPropagation(); staff(item)}}>
                <GrUserWorker className="text-gray-700 mr-2" /> Staffs
            </MenuItem> */}

            {item.status === 4 && (
              <>
                <MenuItem
                  title="Add Bank"
                  onClick={(e) => {
                    e.stopPropagation();
                    bank(item);
                  }}
                >
                  <AiTwotoneBank className="text-gray-700 mr-2" />
                  Add Bank
                </MenuItem>
                <MenuItem title="Extra Charges" onClick={() => charges(item)}>
                  <MdOutlineCurrencyRupee className="text-gray-700 mr-2" />{" "}
                  Extra Charges
                </MenuItem>
                {/* <MenuItem
                  title="Staff"
                  onClick={() =>
                    navigate(`/staff/${item.id}`, {
                      state: { name: item.name },
                    })
                  }
                >
                  <GrUserWorker className="text-gray-700 mr-2" /> Staffs
                </MenuItem> */}
              </>
            )}

            {/* <MenuItem
              title="Upload Rent Agreement"
              onClick={(e) => {
                e.stopPropagation();
                rentagreement(item);
              }}
            >
              <MdFileUpload className="text-gray-700 mr-2" />
              Upload Rent Agreement
            </MenuItem> */}
            {userId === 1 && (
              <MenuItem
                title="Upload Rent Agreement"
                onClick={(e) => {
                  e.stopPropagation();
                  rentagreement(item);
                }}
              >
                <MdFileUpload className="text-gray-700 mr-2" />
                Upload Rent Agreement
              </MenuItem>
            )}
          </MenuOptions>
        )}
        <Btn
          title="Actions"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openMenu(item.id);
          }}
        >
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        _original: item,
        name: getName(item),
        mobile: item.mobile,
        city: getCity(item),
        propCount: propertyCount(item),
        device: getDeviceIcon(item.device),
        lastUsed: getDate(item),
        status: getStatus(item.status),
        action: ActionBtns(item),
        totalHoldedAmount: item.totalHoldedAmount,
        amount: getAmounts(item),
      }));
      setData(tempData);
      // console.log(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <div className="flex items-center gap-1 text-gray-400">
          <p
            className="text-zinc-900 font-semibold cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedData(item);
              setViewDetailStaff(true);
            }}
          >
            {item.name}
          </p>
          <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.name);
              }}
              className="hover:text-gray-600 transition"
              title="Copy name"
            >
              <IoCopySharp size={8} />
          </button>
        </div>
        <div className="flex items-center gap-1 text-xs text-gray-400">
          <p className="text-amber-500 text-xs">#{item.mobile}</p>
          <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.mobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy number"
            >
              <IoCopySharp size={8} />
          </button>
        </div>
      </div>
    );
  };

// const getCity = (item) => {
//   const isLongCityName = item?.city?.length > 15;

//   return (
//     <div
//       className="cursor-pointer"
//       onClick={(e) => {
//         e.stopPropagation();
//         openLogs(item);
//       }}
//     >
//       <div className="text-gray-500 font-medium text-sm">
//         {item?.businessName}
//       </div>

//       <a
//         data-tooltip-id={`tooltip-city-${item.id}`}
//         data-tooltip-content={
//           isLongCityName ? item.city : ""
//         }
//         data-tooltip-delay-show={1000}
//         data-tooltip-place="top"
//         data-tooltip-variant="info"
//         className="max-w-[150px] text-gray-400 font-medium text-xs"
//       >
//         {isLongCityName ? (
//           <p className="cursor-pointer">
//             {item.city.substring(0, 15) + "..."}
//           </p>
//         ) : (
//           item.city || ""
//         )}
//       </a>

//       <Tooltip
//         id={`tooltip-city-${item.id}`}
//         className="!w-60 sm:!w-80"
//       />
//     </div>
//   );
// };


const getCity = (item) => {
  const city = item?.city || "";
  const isLongCityName = city.length > 15;

  const displayCity = isLongCityName
    ? city.substring(0, 15) + "..."
    : city;

  return (
    <div
      className="cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        openLogs(item);
      }}
    >
      <div className="text-gray-500 font-medium text-sm">
        {item?.businessName}
      </div>

      <Tooltip
        label={
          <div className="text-xs leading-5">
            {city || "N/A"}
          </div>
        }
      >
        <p className="text-gray-400 font-medium text-xs cursor-pointer w-fit">
          {displayCity}
        </p>
      </Tooltip>
    </div>
  );
};

  // const propertyCount = (item) => {
  //   const isClickable = item.propCount > 0;
  //   const isClickableBeds = 0;
  //   return (
  //     <div className="flex gap-3">
  //       <div className="flex flex-col ">
  //         <span
  //           className={`${
  //             isClickable
  //               ? "cursor-pointer underline font-semibold"
  //               : "cursor-default"
  //           }`}
  //           onClick={(e) => {
  //             e.stopPropagation();
  //             if (isClickable) goToProperties(item);
  //           }}
  //         >
  //           {"#" + item.propCount}
  //         </span>
  //         <span className="text-gray-400 font-medium text-xs">Properties</span>
  //       </div>
  //       <div className="flex flex-col">
  //         <span
  //           // onClick={() => isClickableBeds && goToOccupancy(item)}
  //           className={
  //             isClickableBeds
  //               ? "cursor-pointer underline font-semibold"
  //               : "cursor-default"
  //           }
  //         >
  //           {item.totalBeds}
  //         </span>
  //         <span className="text-gray-400 font-medium text-xs">Total Beds</span>
  //       </div>
  //     </div>
  //   );
  // };
 
  const propertyCount = (item) => {
    const isClickable = item.propCount > 0;
    const isClickableBeds = 0;
    const content = (
      <div className="flex gap-3">
        <div className="flex flex-col ">
          <span
            className={`${
              isClickable
                ? "cursor-pointer underline font-semibold"
                : "cursor-default"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (isClickable) goToProperties(item);
            }}
          >
            {"#" + item.propCount}
          </span>
          <span className="text-gray-400 font-medium text-xs">Properties</span>
        </div>
        <div className="flex flex-col">
          <span
            // onClick={() => isClickableBeds && goToOccupancy(item)}
            className={
              isClickableBeds
                ? "cursor-pointer underline font-semibold"
                : "cursor-default"
            }
          >
            {item.totalBeds}
          </span>
          <span className="text-gray-400 font-medium text-xs">Total Beds</span>
        </div>
      </div>
    );

    return (
      <Tooltip
        label={
          <div className="text-xs leading-5">
            <div>Total Properties: {item.propCount || 0}</div>
            <div>Total Beds: {item.totalBeds || 0}</div>
            <div>Total Tenants: {item?.tenantCount || 0}</div>
          </div>
        }
      >
        <div className="cursor-pointer w-fit">
          {content}
        </div>
      </Tooltip>
    );
  }

  const getAmounts = (item) => {
    return (
      <div className="flex gap-3">
        <div className="flex flex-col ">
          <span>{item.totalHoldedAmount} </span>
          <span className="text-gray-400 font-medium text-xs">
            Holded Amount
          </span>
        </div>
        <div className="flex flex-col">
          <span>{item.holdOutBalance}</span>
          <span className="text-gray-400 font-medium text-xs">
            Pending Amount
          </span>
        </div>
      </div>
    );
  };

  // const getStatus = (status) => {
  //   if (status === 1) {
  //     return <Unverified>Unverified</Unverified>;
  //   } else if (status === 2) {
  //     return <Verified>Verified</Verified>;
  //   } else if (status === 3) {
  //     return <Active>Active</Active>;
  //   } else {
  //     return <Enrolled>Enrolled</Enrolled>;
  //   }
  // };
  const getStatus = (status) => {
      if (Number(status) === 1) {
        return <Unverified>Unverified</Unverified>;
      } else if (Number(status) === 2) {
        return <Verified>Verified</Verified>;
      } else if (Number(status) === 3) {
        return <Active>Active</Active>;
      } else if (Number(status) === 4) {
        return <Enrolled>Enrolled</Enrolled>;
      } else if (Number(status) === 5) {
        return <Default>Defaulter</Default>;
      } else {
        return <Default>Unknown</Default>;
      }
    };
  const getDate = (item) => {
    return (
      <div className="flex flex-col">
        <span className="">{moment(item.lastLogin).format("DD-MM-YYYY")}</span>
        <span className="text-gray-400 font-medium text-xs">
          {moment(item.lastLogin).format("hh:mm A")}
        </span>
      </div>
    );
  };

  const getDeviceIcon = (device) => {
    switch (device) {
      case 1:
        return <DiAndroid className="text-gray-500 text-lg" />;
      case 2:
        return <FaApple className="text-gray-500 text-lg" />;
      case 3:
        return <FaWindows className="text-gray-500 text-lg" />;
      default:
        return <DiAndroid className="text-gray-500 text-lg" />;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Owner Name",
          accessor: "name",
        },
        {
          Header: "Property/Beds",
          accessor: "propCount",
        },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "Owner Details",
        accessor: "name",
      },
      {
        Header: "City",
        accessor: "city",
      },
      {
        Header: "Property/Beds",
        accessor: "propCount",
      },
      {
        Header: "Last Used",
        accessor: "lastUsed",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        {/* <Tbody {...getTableBodyProps()} hasdata={apiData?.length > 0}> */}
        <Tbody
          {...getTableBodyProps()}
          className={apiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                {/* <Tr {...row.getRowProps()} hasdata={apiData?.length > 0}> */}
                <Tr
                  {...row.getRowProps()}
                  className={apiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>City:</strong> {data[rowIndex].city}
                        </li>
                        <li>
                          <strong>Created At:</strong> {data[rowIndex].date}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
// const Tbody = tw.tbody`${(props) => (props.hasdata ? "border-b" : "")}`;
// const Tr = tw.tr`${(props) =>
//   props.hasdata
//     ? "border-b"
//     : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Tbody = tw.tbody`${({ hasdata }) => (hasdata ? "border-b" : "")}`;
const Tr = tw.tr`${({ hasdata }) =>
  hasdata ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const Active = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Verified = tw.div`bg-teal-100 text-teal-700 text-xs border-teal-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Unverified = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Enrolled = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const MenuOptions = tw.div`absolute bottom-0 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col overflow-y-auto`;
const MenuItem = tw.div`flex items-center gap-2 pl-4 py-2 pr-5 text-base font-medium cursor-pointer hover:bg-gray-100`;
const Default = tw.div`bg-red-100 text-red-700 text-xs border-red-300 border w-24 h-7 flex items-center justify-center rounded-full`;
export default RecentUsedTable;
